export const CREATE_DMX_UNIVERSE = 'CREATE_DMX_UNIVERSE';
export const CREATE_DMX_UNIVERSE_SUCCESSFUL = 'CREATE_DMX_UNIVERSE_SUCCESSFUL';
export const CREATE_DMX_UNIVERSE_FAILED = 'CREATE_DMX_UNIVERSE_FAILED';
